
import './LoadingAnimation.css';

export default function LoadingAnimation() {
    return (
        <div className="loading-overlay">
          <div className="loading-container">
            <div className="login-spinner"></div>
          </div>
        </div>
    )
}